'use strict';

var React = require('react'),
    Checkbox = require('../Checkbox');

var DropdownCheckboxItem = React.createClass({
    displayName: 'DropdownCheckboxItem',


    propTypes: {
        selected: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.object]),
        onListItemClicked: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
        return {
            item: '',
            label: '',
            selected: false,
            onListItemClicked: function onListItemClicked(item, event) {}
        };
    },

    handleClick: function handleClick(event) {
        this.props.onListItemClicked(this.props.item, event);
    },

    render: function render() {
        return React.createElement(Checkbox, { label: this.props.label,
            onChange: this.handleClick,
            checked: this.props.selected ? true : false });
    }
});

module.exports = DropdownCheckboxItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/Dropdown/DropdownCheckboxItem.js
// module id = 668
// module chunks = 2 7 8 11 13 19 20 21 25 26